var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21876 0.996094C7.79023 0.996094 9.88477 3.09063 9.88477 5.6621C9.88477 6.70807 9.28752 7.95714 8.89816 8.68056L5.63195 14.7464C5.5789 14.8474 5.4908 14.9254 5.38426 14.9657C5.27762 15.0062 5.16001 15.0062 5.05336 14.9657C4.94683 14.9254 4.85873 14.8474 4.80568 14.7464L1.53947 8.68056C1.15008 7.95725 0.552861 6.70818 0.552861 5.6621C0.552861 3.09063 2.6474 0.996094 5.21887 0.996094H5.21876ZM5.21876 1.92935C3.15166 1.92935 1.48595 3.59503 1.48595 5.66216C1.48595 6.28793 2.01768 7.592 2.36572 8.23818L5.21865 13.536L8.07185 8.23818C8.41978 7.59189 8.95151 6.28793 8.95151 5.66216C8.95151 3.59506 7.28583 1.92935 5.2187 1.92935H5.21876ZM5.21876 3.17365C6.58759 3.17365 7.70735 4.29338 7.70735 5.66224C7.70735 7.0311 6.58773 8.15083 5.21876 8.15083C3.84992 8.15083 2.73017 7.0311 2.73017 5.66224C2.73017 4.29338 3.84978 3.17365 5.21876 3.17365ZM5.21876 4.1069C4.3543 4.1069 3.66342 4.79778 3.66342 5.66224C3.66342 6.5267 4.35419 7.21758 5.21876 7.21758C6.08322 7.21758 6.77409 6.5267 6.77409 5.66224C6.77409 4.79778 6.08322 4.1069 5.21876 4.1069Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/location-pin-icon.e9a95640dd80fc9d9a0192e4dd36c43e.svg";
export { ForwardRef as ReactComponent };